<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>UPSI Master</strong>
        </span>
        <span style="float:right">

            <button type="button" class="btn btn-sm btn-primary pull-right"
                [appHasPermission]="{'Url': '/upsimaster/add', 'method':'post', 'menu': 'UPSI Master'}"
                (click)="addModel()">Add New </button>
        </span>

    </div>
    <div class="modal" id="AddModel" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true" style="top: 50px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Add New</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>

                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <input type="text" [(ngModel)]="item" class='form-control'>
                            <div *ngIf="disabledText" class="form-control-error-custom">
                                Please enter the Nature of UPSI.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">
                        <i class="fa fa-times"></i>Cancel</button>
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="itemId" (click)="save(itemId)"
                        [disabled]="disabledOnclick">
                        Update</button>
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="!itemId" (click)="save()"
                        [disabled]="disabledOnclick">
                        Save</button>
                </div>
            </div>
        </div>
    </div>


    <div class="card-block datatable-card-block">
        <div class="row">
            <div class="col-md-12">
                <div class="margin-bottom-50">
                    <div class="table-responsive">


                        <table id="EmailsLogsT" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                            class="table table-hover compact cell-border nowrap stripe" id="CsvUploadtable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th style="min-width:200px">Nature of UPSI</th>
                                    <th style="min-width:200px">Created Date</th>
                                    <th style="min-width:200px">Modified Date</th>
                                    <th style="min-width:200px">Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of ItemList">
                                    <td style="min-width:200px">{{item.Item }}</td>
                                    <td style="min-width:200px">{{item.CreatedDate | date : "dd-MM-y"}}</td>
                                    <td style="min-width:200px">{{item.ModifiedDate | date : "dd-MM-y"}}</td>
                                    <td style="min-width:200px; text-align: center;">
                                        <button (click)="edit(item._id)" type="button" class="btn-sm btn btn-warning"
                                            title="Edit"
                                            [appHasPermission]="{'Url': '/upsimaster/edit', 'method':'put', 'menu': 'UPSI Master'}">
                                            <span class="fa fa-pencil"></span>
                                        </button>
                                        <button type="button" title="Delete" (click)='deletePop(item._id)'
                                            class="btn-sm btn btn-danger"
                                            [appHasPermission]="{'Url': '/upsimaster/delete', 'method':'delete', 'menu': 'UPSI Master'}">
                                            <span class="icmn-bin"></span>
                                        </button>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>
<div class="modal " id="deleteConfirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true" style="top: 50px;">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDeletion">
                    <i class="fa fa-question-circle-o mr-2"></i>Confirm
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <i class="fa fa-times"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-12">
                        Are you sure you want to delete this item?
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">
                    <i class="fa fa-times"></i>No</button>
                <button type="button" class="btn btn-sm btn-primary" (click)="delete()" data-dismiss="modal">
                    <i class="fa fa-check"></i>Yes</button>

            </div>
        </div>
    </div>
</div>
<app-alert2></app-alert2>